import React from 'react';
import './EmailJourneyEntry.css';

export const EMAIL_JOURNEYS = {
  'skin-type': {
    eyebrow: 'Your skin type, explained',
    title: 'Start with your skin',
    body: 'A quick guided scan helps Son:mi understand your skin type and gives you a useful baseline for future check-ins.',
    returningLabel: 'Sign in to my account',
    newLabel: "I'm new — start my scan",
    destination: 'scan',
  },
  'product-analysis': {
    eyebrow: 'Check a new product',
    title: 'Sign in before you analyse',
    body: 'Son:mi uses your skin profile and current routine to make the analysis personal to you.',
    returningLabel: 'Sign in to my account',
    newLabel: 'Create an account',
    destination: 'product-analysis',
    requiresAccount: true,
  },
};

export function getEmailJourney(search = '') {
  const key = new URLSearchParams(search).get('open');
  return key && EMAIL_JOURNEYS[key] ? { key, ...EMAIL_JOURNEYS[key] } : null;
}

export default function EmailJourneyEntry({ journey, onSignIn, onStartNew }) {
  if (!journey) return null;
  return (
    <main className="email-journey">
      <section className="email-journey__card">
        <div className="email-journey__mark" aria-hidden="true"><span><i /></span></div>
        <p className="email-journey__eyebrow">{journey.eyebrow}</p>
        <h1 className="email-journey__title">{journey.title}</h1>
        <p className="email-journey__body">{journey.body}</p>
        <div className="email-journey__actions">
          <button className="email-journey__primary" type="button" onClick={onStartNew}>{journey.newLabel}</button>
          <button className="email-journey__secondary" type="button" onClick={onSignIn}>{journey.returningLabel}</button>
        </div>
      </section>
    </main>
  );
}
